import { Pagination } from "@mui/material";
import {
  ArchiveIcon,
  AvatarIcon,
  CalendarIcon,
  Cross2Icon,
  HomeIcon,
  PersonIcon,
  SewingPinFilledIcon,
} from "@radix-ui/react-icons";
import { useEffect, useState } from "react";
import ReactDatePicker from "react-datepicker";
import { NavLink } from "react-router-dom";
import {
  checkTagValidity,
  getUserProfil,
  months,
  years,
} from "../../Utils/Utils";
import {
  BASE_URL,
  EN_ATTENTE_SOUSCRIPTION,
  EXPORT_RAPPORT,
  LIST_SOUSCRIPTION,
} from "../../Utils/constant";
import { ContentLoading } from "../../components/Widget/ContentLoading";
import { Pbo } from "../../components/Widget/Pbo";
import { Periode } from "../../components/Widget/Periode";
import { Tabs } from "../../components/Widget/Tab";
import { useStoreLivraison } from "../../store/livraisonStore";
import { useStoreApp } from "../../store/storeApp";

const Souscription = () => {
  const [page, setPage] = useState(0);
  const [dateRange, setDateRange] = useState([null, null]);
  const [startDate, endDate] = dateRange;
  const [select, setSelect] = useState("ANNEE");
  const [selectItem, setSelectItem] = useState(null);
  const [active, setActive] = useState({
    index: 0,
    value: "En attente de souscription",
  });

  const more = (page) => {
    setPage(page - 1);
    listSouscriptions.getData(
      LIST_SOUSCRIPTION,
      { page: page - 1, param: "", size: 10 },
      "&periode=&mois=&annee=&dateDebut=&dateFin=",
    );
  };

  const moreEnAttente = (page) => {
    souscription.getData(
      EN_ATTENTE_SOUSCRIPTION,
      { page: 0, param: page - 1, size: 10 },
      "&dateDebut=&dateFin=&inTime=",
    );
  };

  const listSouscriptions = useStoreLivraison();
  const souscription = useStoreApp();
  const listeTabsData = [
    {
      index: 0,
      value: "En attente de souscription",
      tag: "LISTE_EN_ATTENTE_SOUSCRIPTION",
    },
    {
      index: 1,
      value: "Souscrit",
      tag: "LISTE_SOUSCRIPTION",
    },
  ];
  const filteredTabsData = listeTabsData
    .filter((tab) => checkTagValidity(tab.tag))
    .map((tab, index) => ({ ...tab, index }));

  useEffect(() => {
    if (filteredTabsData.length !== 0) {
      setActive(filteredTabsData[0]);
    }
    souscription.getListSouscription(
      EN_ATTENTE_SOUSCRIPTION,
      { page: 0, param: "", size: 10 },
      "&dateDebut=&dateFin=&inTime=",
    );
    listSouscriptions.getData(
      LIST_SOUSCRIPTION,
      { page: 0, param: "", size: 10 },
      "&periode=&mois=&annee=&dateDebut=&dateFin=&inTime=",
    );
  }, []);

  const handleDownload = () => {
    const user = getUserProfil();
    fetch(
      `${BASE_URL + EXPORT_RAPPORT}?model=SOUSCRIPTIONS&username=${
        user?.username
      }`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({}),
      },
    )
      .then((response) => response.blob())
      .then((blob) => {
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.style.display = "none";
        a.href = url;
        a.download = `RAPPORT_SOUSCRIPTIONS.xlsx`; // spécifiez le nom du fichier et son extension
        document.body.appendChild(a);
        a.click();
      })
      .catch((err) => console.error("Erreur de téléchargement:", err));
  };

  return (
    <div className="">
      <div className="lg:flex gap-8 items-center">
        <h3 class="text-3xl font-bold font-mtn">Souscription</h3>
        <div className="ml-auto lg:flex gap-x-3">
          <select
            onChange={(e) => {
              setSelect(e.target.value);
            }}
            className="my-2 select"
          >
            <option>Periode</option>
            <option value="MOIS">Filtre par mois</option>
            <option value="ANNEE" selected>
              Filtre par années
            </option>
          </select>
          {select === "MOIS" ? (
            <select onChange={(e) => {}} className="my-2 select">
              <option disabled selected>
                mois
              </option>
              {months.map((item) => (
                <option value={item.code}>{item.name}</option>
              ))}
            </select>
          ) : select === "ANNEE" ? (
            <select onChange={(e) => {}} className="my-2 select ">
              <option disabled selected>
                années
              </option>
              {years.map((item) => (
                <option
                  value={item.name}
                  selected={
                    new Date().getFullYear() === Number(item.name)
                      ? true
                      : false
                  }
                >
                  {item.name}
                </option>
              ))}
            </select>
          ) : (
            <ReactDatePicker
              dateFormat="dd-MM-yyyy"
              selected={startDate}
              onChange={(update) => {
                if (update[1] != null) {
                }
                setDateRange(update);
              }}
              startDate={startDate}
              endDate={endDate}
              selectsRange
              className="text-xs font-normal cursor-pointer btn btn-sm hover:bg-gray-100 text-center h-8 my-2 w-52 rounded-md border border-input bg-gray-100 px-3 py-1 shadow-sm"
            />
          )}
        </div>
      </div>
      {filteredTabsData.length !== 0 ? (
        <Tabs
          tabsData={filteredTabsData}
          active={active}
          setActive={setActive}
        />
      ) : null}
      <div className="bg-white rounded-md px-2 py-4 mt-3">
        {active.index === 0 ? (
          <>
            <div className="mt-3 lg:flex gap-1 items-center">
              <input
                type="text"
                placeholder="Rechercher element..."
                className="text-xs input input-bordered px-3 w-80 h-10 text-gray-900 placeholder:text-gray-400"
                onChange={(e) =>
                  souscription.getListSouscription(
                    EN_ATTENTE_SOUSCRIPTION,
                    { page: 0, param: e.target.value, size: 10 },
                    `&dateDebut=&dateFin=&inTime=`,
                  )
                }
              />

              <select
                onChange={(e) =>
                  souscription.getListSouscription(
                    EN_ATTENTE_SOUSCRIPTION,
                    { page: 0, param: "", size: 10 },
                    `&dateDebut=&dateFin=&inTime=${e.target.value}`,
                  )
                }
                className="select pl-non my-3"
              >
                <option disabled selected>
                  Delais de traitement
                </option>
                <option value="">Tout afficher</option>
                <option value={"true"}>Intention dans le delais</option>
                <option value={"false"}>Intention hors delais</option>
              </select>
            </div>
            <div className=" grid  lg:grid-cols-3 md:grid-cols-3 sm:grid-cols-2 mt-4 grid-cols-1 gap-5">
              {souscription?.listSouscriptions?.data?.length === 0 ? (
                <div className="">
                  <p className="text-sm ">Aucune donnée </p>
                </div>
              ) : souscription?.listSouscriptions?.data?.length !== 0 &&
                !souscription?.loading ? (
                souscription?.listSouscriptions?.data?.map((item) => (
                  <div
                    className={`${
                      item?.statusSuppression === "EN_ATTENTE" && "opacity-30"
                    }  relative bg-white rounded-xl border-slate-200 border shadow-md`}
                  >
                    <div className="rounded-t-xl flex items-center gap-3 border-b border-dashed border-amber-400 px-2 py-3">
                      <p className="text-[12px] font-semibold">
                        N° {item?.abonnement?.eligibilite?.numeroTicket}
                      </p>
                      <div className="ml-auto flex items-center gap-2">
                        <div
                          className={` px-1 border  rounded-full py-[2px] text-xs ${
                            item?.abonnement?.statusConfirmation === "CONFIRMER"
                              ? "text-green-600"
                              : "text-gray-500"
                          }  font-semibold`}
                        >
                          {item?.abonnement?.statusConfirmation?.toLowerCase()}
                        </div>
                      </div>
                    </div>
                    <div className=" px-3 py-2 ">
                      <div className="items-center gap-2 space-y-3">
                        <Periode item={item} />
                        {/* <p className="mb-2  text-gray-500 text-xs font-medium">{new Date(item?.abonnement?.dateCreation).toLocaleString()}</p> */}
                        <Pbo
                          pbo={item?.abonnement?.eligibilite?.pbo?.nom}
                          port={item?.brin}
                        />
                        <div className="flex gap-1 my-3">
                          <PersonIcon className="bg-gray-100 rounded-full w-8 h-8 p-2" />
                          <div>
                            <p className="text-[13px] font-medium">
                              {item?.abonnement?.client?.nomPrenoms}
                            </p>
                            <p className="text-xs flex font-semibold gap-2">
                              <span>{item?.abonnement?.client?.numero}</span>{" "}
                              {" | "}{" "}
                              <span>
                                {item?.abonnement?.client?.secondNumero}
                              </span>{" "}
                            </p>
                          </div>
                        </div>
                        <div className="animate-pulse border-dashed border w-fit px-1 py-[2px] bg-red-50 text-red-800 border-red-600 rounded">
                          <p className="text-xs flex gap-1 items-center font-medium">
                            <CalendarIcon />
                            {item?.dateRdv +
                              " de " +
                              item?.crenau?.heureDebut +
                              " à " +
                              item?.crenau?.heureFin}
                          </p>
                        </div>
                        <h1 className="text-xs flex gap-1 items-center my-2">
                          <AvatarIcon />
                          Equipe en charge : {item?.equipe?.designation}
                        </h1>

                        <h1 className="text-xs flex gap-1 items-center my-2">
                          Forfait : {item?.abonnement?.forfait?.designation} -{" "}
                          {item?.abonnement?.forfait?.categorie
                            ?.replace("_", "")
                            .toLowerCase()}
                        </h1>

                        <div className=" gap-1 ">
                          <div>
                            <p className="text-[13px] font-medium">
                              Numero FTTH : {item?.abonnement?.numeroFtth}
                            </p>
                            {/* <p className="text-xs flex font-semibold gap-2">
                              SN : <span>{item?.abonnement?.numeroSerie}</span>
                            </p> */}
                          </div>
                        </div>

                        <div className="pb-3 pt-1 border-b flex gap-4 items-center">
                          <p className="text-xs flex gap-1 items-center font-medium">
                            <HomeIcon />
                            {item?.abonnement?.batiment?.designation}
                          </p>
                          <p className="text-xs flex gap-1 font-medium">
                            <ArchiveIcon />{" "}
                            {item?.abonnement?.equipement?.designation}{" "}
                          </p>
                        </div>
                      </div>
                      <h1 className="my-2 text-[13px] font-medium flex items-center">
                        <SewingPinFilledIcon />
                        {item?.abonnement?.commune +
                          ", " +
                          item?.abonnement?.quartier}
                      </h1>
                      <div className="flex items-center gap-1">
                        <h5 className="text-xs font-medium ">Etape:</h5>
                        <p className=" bg-blue-50 text-blue-900 py-1 px-1 rounded-lg font-medium text-xs truncate">
                          {item?.abonnement?.status
                            ?.toLowerCase()
                            .replace(/_/g, " ")}
                        </p>
                      </div>

                      {checkTagValidity("POURSUIVRE_SOUSCRIPTION") &&
                      item?.statusSuppression !== "EN_ATTENTE" ? (
                        <NavLink
                          className="btn btn-sm bg-main my-3 font-mtn text-xs font-regular"
                          to={`poursuivre-intention/${item?.abonnement?.eligibilite?.numeroTicket}/10`}
                        >
                          Poursuivre
                        </NavLink>
                      ) : null}
                    </div>
                  </div>
                ))
              ) : (
                <ContentLoading />
              )}
            </div>
            <div className="my-3 flex justify-end">
              <Pagination
                onChange={(event, newValue) => moreEnAttente(newValue)}
                onSelect={(selectedPage) => moreEnAttente(selectedPage)}
                count={souscription?.data?.totalPages}
                variant="outlined"
                color="primary"
                shape="rounded"
              />
            </div>
          </>
        ) : active.index === 1 ? (
          <>
            <div className="mt-3 lg:flex gap-1 items-center">
              <input
                onChange={(e) => {
                  listSouscriptions.getData(
                    LIST_SOUSCRIPTION,
                    { page: 0, param: e.target.value, size: 10 },
                    "&periode=&mois=&annee=&dateDebut=&dateFin=&inTime=",
                  );
                }}
                type="text"
                placeholder="Rechercher element..."
                className="text-xs input input-bordered px-3 w-80 h-10 text-gray-900 placeholder:text-gray-400"
              />
              <select
                onChange={(e) =>
                  listSouscriptions.getData(
                    LIST_SOUSCRIPTION,
                    { page: 0, param: "", size: 10 },
                    `&periode=&mois=&annee=&dateDebut=&dateFin=&inTime=${e.target.value}`,
                  )
                }
                className="select pl-non my-3"
              >
                <option disabled selected>
                  Delais de traitement
                </option>
                <option value="">Tout afficher</option>
                <option value={"true"}>Intention dans le delais</option>
                <option value={"false"}>Intention hors delais</option>
              </select>
            </div>
            <div>
              <button
                className="mt-2 btn btn-sm bg-main text-black"
                onClick={handleDownload}
              >
                Exporter
              </button>

              <div className="grid md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-3 2xl:grid-cols-3 gap-2 my-4">
                {listSouscriptions?.data?.data?.length === 0 ? (
                  <div className="flex justify-center items-center">
                    <p>Aucune donnée</p>
                  </div>
                ) : listSouscriptions?.data?.data?.length !== 0 &&
                  !listSouscriptions?.loading ? (
                  listSouscriptions?.data?.data?.map((item) => (
                    <div className="relative bg-white rounded-xl border-slate-200 border shadow-sm">
                      <div className="rounded-t-xl flex items-center gap-3 border-b-[2px] border-orange-100 px-4 py-3">
                        <p className="text-[12px] font-semibold">
                          Ticket N°{item?.abonnement?.eligibilite?.numeroTicket}
                        </p>
                      </div>
                      <div className="px-3 py-2">
                        <div className="my-1 flex items-center">
                          <div className="flex items-center gap-2">
                            <Pbo
                              pbo={item?.abonnement?.eligibilite?.pbo?.nom}
                              port={item?.brin}
                            />
                          </div>
                        </div>
                        <h1 className="text-xs flex gap-1 items-center my-2">
                          Forfait : {item?.abonnement?.forfait?.designation} -{" "}
                          {item?.abonnement?.forfait?.categorie
                            ?.replace("_", "")
                            .toLowerCase()}
                        </h1>
                        <div className=" gap-1 ">
                          <div>
                            <p className="text-[13px] font-medium">
                              Numero FTTH : {item?.abonnement?.numeroFtth}
                            </p>
                            {/* <p className="text-xs flex font-semibold gap-2">
                              SN : <span>{item?.abonnement?.numeroSerie}</span>
                            </p> */}
                          </div>
                        </div>

                        <div className="items-center gap-2 space-y-3">
                          <h1 className="text-xs flex items-center my-2">
                            <SewingPinFilledIcon />
                            Lieu de raccordement :{" "}
                            {item?.abonnement?.commune +
                              ", " +
                              item?.abonnement?.quartier}
                          </h1>

                          <div className="pb-3 border-b gap-4 items-center">
                            <p className="text-xs flex gap-1 items-center font-medium">
                              <CalendarIcon /> Date de souscription :
                              {" " + item?.dateH
                                ? new Date(item?.dateH).toLocaleString()
                                : "--"}
                            </p>
                            <div className="mt-2 flex items-center">
                              <p className="text-xs font-medium text-blue-700">
                                Commentaire: {item?.commentaire}{" "}
                              </p>
                            </div>
                            <div className="mt-2 flex items-center gap-2 border-t pt-3">
                              <PersonIcon className="bg-gray-100 rounded-full w-8 h-8 p-2" />
                              <div>
                                <p className="text-[13px] font-medium">
                                  {item?.abonnement.client?.nomPrenoms}
                                </p>
                                <p className="text-xs flex font-semibold gap-2">
                                  <span>{item?.abonnement.client?.numero}</span>{" "}
                                  {" | "}{" "}
                                  <span>
                                    {item?.abonnement.client?.email}
                                  </span>{" "}
                                </p>
                              </div>
                            </div>
                          </div>

                          {checkTagValidity("DETAILS_SOUSCRIPTION") ? (
                            <div className="flex gap-1 ">
                              <button
                                onClick={() => {
                                  setSelectItem(item);
                                  document
                                    .getElementById("souscrit")
                                    .showModal();
                                }}
                                className="btn btn-sm bg-main text-xs"
                              >
                                Details de souscription
                              </button>
                            </div>
                          ) : null}

                          <dialog id="souscrit" className="modal rounded-none">
                            <div className="relative modal-box">
                              <div className="modal-action">
                                <h1 className="mr-auto text-amber-500 text-2xl font-bold font-mtn">
                                  Details de souscription
                                </h1>
                                <form method="dialog">
                                  <button
                                    id="close"
                                    className="absolute top-4 right-4"
                                  >
                                    <Cross2Icon />
                                  </button>
                                </form>
                              </div>
                              <div className="rounded-lg">
                                <div className="sm:px-0">
                                  <h3 className="lg:text-sm text-2xl text-gray-900 mb-6">
                                    Information sur la souscription du client
                                  </h3>
                                </div>
                                <div className="mt-2 border-t border-gray-100">
                                  <dl className="divide-y divide-gray-100">
                                    <div className="px-4 py-3 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0">
                                      <dt className="text-sm font-bold leading-6 text-gray-900">
                                        Forfait souscrit
                                      </dt>
                                      <dd className="mt-1 text-sm leading-6 text-gray-700 sm:col-span-2 sm:mt-0">
                                        {item?.abonnement?.forfait
                                          ?.designation ?? "--"}
                                      </dd>
                                    </div>

                                    <div className="px-4 py-3 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0">
                                      <dt className="text-sm font-bold leading-6 text-gray-900">
                                        Categorie du forfait
                                      </dt>
                                      <dd className="mt-1 text-sm leading-6 text-gray-700 sm:col-span-2 sm:mt-0">
                                        {item?.abonnement?.forfait?.categorie ??
                                          "--"}
                                      </dd>
                                    </div>

                                    <div className="px-4 py-3 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0">
                                      <dt className="text-sm font-bold leading-6 text-gray-900">
                                        OfferId
                                      </dt>
                                      <dd className="mt-1 text-sm leading-6 text-gray-700 sm:col-span-2 sm:mt-0">
                                        {item?.abonnement?.forfait?.offerId ??
                                          "--"}
                                      </dd>
                                    </div>

                                    <div className="px-4 py-3 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0">
                                      <dt className="text-sm font-bold leading-6 text-gray-900">
                                        Equipement
                                      </dt>
                                      <dd className="mt-1 text-sm leading-6 text-gray-700 sm:col-span-2 sm:mt-0">
                                        {item?.abonnement?.forfait?.equipement
                                          ?.designation ?? "--"}
                                      </dd>
                                    </div>
                                  </dl>
                                </div>
                              </div>
                            </div>
                          </dialog>
                        </div>
                      </div>
                    </div>
                  ))
                ) : (
                  <ContentLoading />
                )}
              </div>
            </div>
            <div className="my-3 flex justify-end">
              <Pagination
                onChange={(event, newValue) => more(newValue)}
                onSelect={(selectedPage) => more(selectedPage)}
                count={listSouscriptions?.data?.totalPages}
                variant="outlined"
                color="primary"
                shape="rounded"
              />
            </div>
          </>
        ) : null}
      </div>
    </div>
  );
};

export default Souscription;
